/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { createDialogRoute, getDialogInitData } from '@gh/common-shared';
import { DialogInput } from '@gh/core-ui';
import { LogDialogConfig, LogDialogPreloadService } from './log-dialog-preload.service';

@Component({
  standalone: false,
  selector: 'gh-log-dialog',
  templateUrl: 'log-dialog.component.html',
  styleUrls: ['log-dialog.component.scss'],
})
export class LogDialogComponent implements DialogInput<LogDialogConfig>, OnInit {
  input: LogDialogConfig;
  text: string;

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any) {
  }

  ngOnInit(): void {
    this.text = getDialogInitData(this.dialogData);
  }
}

export const logDialogRoute = createDialogRoute({
  component: LogDialogComponent,
  init: LogDialogPreloadService,
});
